import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCirclePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"circle-plus, add"} maskId="square-filled-radius-0-stroke-1-IconCirclePlus"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM7.25735 11.5V12.5H11.5V16.7426H12.5V12.5H16.7426V11.5H12.5V7.25736H11.5V11.5H7.25735Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCirclePlus;
